{
  "user-profile-page": {
    "meta": {
      "title": "Profil",
      "description": "Benutzerprofil"
    }
  }
}
